// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1kLlI","head":"ProcedureTableInfo_head__1hkxK"};